module.exports = __webpack_public_path__ + "img/hiw_icon_Manage_Census.3aad78f1.png";